import { render, staticRenderFns } from "./ShowPoliciesList.vue?vue&type=template&id=2ef3803e&scoped=true&"
import script from "./ShowPoliciesList.vue?vue&type=script&lang=js&"
export * from "./ShowPoliciesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3803e",
  null
  
)

export default component.exports